module.exports = __webpack_public_path__ + "img/u30727 (1).47c77fe5.png";